import React from 'react';

//COMPONENTS
import { Row, Column, IBox, Title, Content, Button, Select, Icon } from '../inspinia';
import Pagination from 'react-js-pagination';
import { withRouter } from 'react-router-dom';

//MASK
import InputMask from 'react-input-mask';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';

//HELPERS
import * as c from '../../helpers/constants';
import { getToken } from '../../store/auth';
import { callApi } from '../../helpers/methods'

//REDUX
import { connect } from 'react-redux';
import { CircularProgress } from '@material-ui/core';
import { relatorioAction } from '../../store/relatorio';
import { bindActionCreators } from 'redux';

class downloadRelatorio extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            page: 0,
            form: {
                dataInicio: "",
                dataFim: "",
                filial: { id: 0 },
                tipoRelatorio: "Selecione...",
            },
            list:
            {
                currentPage: 0, pageNumber: 0, size: 0, totalElements: 0, content: undefined
            },
            comboEmpresa:
            {
                results: undefined
            },
            comboTipoRelatorio:
            {
                results: undefined
            },

            downloading: false,
            alerta: withReactContent(Swal),
            process: false,


            optionsGet: { method: 'GET', headers: { 'Content-Type': 'application/json' } }
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleChangeEmpresa = this.handleChangeEmpresa.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handlePesquisarRelatorio = this.handlePesquisarRelatorio.bind(this);
    }

    handleChange(e) {
        const form = this.state.form;
        this.state.isLoggedIn = false;
        this.setState({ form: { ...form, [e.target.name]: e.target.value } });
    }

    handleChangeEmpresa(e) {
        const form = this.state.form;
        this.state.isLoggedIn = false;
        this.setState({ form: { ...form, [e.target.name]: { id: e.target.value } } });
    }

    componentDidMount() {
        this.LoadComboEmpresa();
        this.LoadComboTipoRelatorio();
        this.loadListaRelatorio();
    }

    LoadComboEmpresa() {
        const self = this;
        const data = JSON.stringify({
            'id_produto': null
        });
        const url = `${c.API_BASE_URL}/company-user`;
        const options = {
            method: 'POST',
            body: data
        };

        this.comboEmpresaSubscription = callApi(url, options, function (response) {
            self.setState({ ...self.state, comboEmpresa: response });
        });
    }

    LoadComboTipoRelatorio() {
        let self = this;

        const url = `${c.API_BASE_URL}/relatorios-download-filter`;
        const options = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        };

        self.setState({ ...self.state, loading: true });

        this.comboTipoRelatorioSubscription = callApi(url, options, function (response) {
            self.setState({ ...self.state, loading: false, comboTipoRelatorio: response });
        });
    }

    loadListaRelatorio(pageNumber) {
        const self = this; 
        let page = pageNumber === undefined ? 0 : --pageNumber;
        let size = 10;

        const url = `${c.API_BASE_URL}/buscaRelatorios?page=${page}&size=${size}`;

        const options = self.state.optionsGet;

        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            self.setState({
                ...self.state, loading: false, list: {
                    currentPage: response.number, pageCount: response.totalPages, pageSize: response.size, rowCount: response.totalElements, results: response.content
                }
            })
        });
    }

    handlePesquisarRelatorio() {

        if (this.state.form.dataInicio === "" && this.state.form.dataFim === "") {
            c.TOASTER_INFO("Para realizar essa pesquisa é necessário informar algum filtro de data.");
            return;
        }

        if (this.state.form.dataInicio === "") {
            c.TOASTER_INFO("Para realizar essa pesquisa é necessário informar data de início.");
            return;
        }

        if (this.state.form.dataFim === "") {
            c.TOASTER_INFO("Para realizar essa pesquisa é necessário informar data fim.");
            return;
        }

        this.setState({ ...this.state, page: 1 }, this.LoadTable(1));
    }

    handleRelatorio(pageNumber) {
        this.LoadTable(pageNumber);
    }

    LoadTable(pageNumber) {

        let self = this;
        let page = pageNumber === undefined ? 0 : --pageNumber;
        let size = 10;
        let filial = this.state.form.filial.id;
        let tipoRelatorio = this.state.form.tipoRelatorio;

        if (filial == "Selecione...") {
            filial = "0";
        }

        if (tipoRelatorio == "Selecione...") {
            tipoRelatorio = "0";
        }

        let url = "";

        url = `${c.API_BASE_URL}/buscar-relatorio-agendado?page=${page}&size=${size}&dataInicio=${self.state.form.dataInicio}&dataFim=${self.state.form.dataFim}&filial=${filial}&tipoRelatorio=${tipoRelatorio}`;

        const options = self.state.optionsGet;

        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            self.setState({
                ...self.state, loading: false, list: {
                    currentPage: response.number, pageCount: response.totalPages, pageSize: response.size, rowCount: response.totalElements, results: response.content
                }
            })
        });
    }

    handlePageChange(pageNumber) {
        this.state.page = pageNumber;

        if (this.state.form.dataInicio == "" && this.state.form.dataFim == "") {
            this.loadListaRelatorio(pageNumber);
        } else {
            this.LoadTable(pageNumber);
        }  
    }

    render() {

        return (

            <div>
                {/* MAIN CONTENT */}
                <Row className="mb-0">
                    <Column>
                        <IBox>
                            <Title>
                                <h3 className="text-slate-grey">Download Relatório</h3>
                            </Title>

                            <Content>
                                <Row>
                                    <Column size="2" className="p-1 mx-auto container">
                                        <label>Data Inicio:</label>
                                        <InputMask mask="99/99/9999" name="dataInicio" value={this.state.form.dataInicio} placeholder="___/___/___" onChange={this.handleChange} readOnly={this.state.process} className="form-control" />
                                    </Column>

                                    <Column size="2" className="p-1 mx-auto container">
                                        <label>Data Fim:</label>
                                        <InputMask mask="99/99/9999" name="dataFim" value={this.state.form.dataFim} placeholder="___/___/___" onChange={this.handleChange} readOnly={this.state.process} className="form-control" />
                                    </Column>

                                    <Column size="2" className="p-1 mx-auto container">
                                        <label>Filial:</label>
                                        <Select name="filial" selected={this.state.form.filial.id} data={this.state.comboEmpresa} onChange={this.handleChangeEmpresa} placeholder="Filial" />
                                    </Column>

                                    <Column size="3" className="p-1 mx-auto container">
                                        <label>Filtros:</label>
                                        <Select name="tipoRelatorio" selected={this.state.form.tipoRelatorio} data={this.state.comboTipoRelatorio} onChange={this.handleChange} placeholder="Tipo Relatório" />
                                    </Column>
                                </Row>

                                <Row className="m-0 mb-3">
                                    <Column size="auto" className="mx-auto">
                                        <div className="input-group" >
                                            <Button className="mx-1" onClick={this.handlePesquisarRelatorio} width="130px">Buscar</Button>

                                            <div className="ml-4">
                                                {this.state.loading && (
                                                    <CircularProgress
                                                        size={30}
                                                        thickness={4}
                                                        color='inherit'
                                                        variant='indeterminate' />
                                                )}
                                            </div>
                                        </div>
                                    </Column>
                                </Row>

                                {/* TABELA */}
                                <Row className="m-0 mb-0">
                                    <Column className="p-0 table-responsive">
                                        <Table data={this.state.list} history={this} loading={this.state.loading} />
                                    </Column>
                                </Row>
                            </Content>
                        </IBox>
                    </Column>
                </Row>
                {/* FOOTER */}
                <Row className="mb-5">
                    <Column className="container">
                        <Row>
                            <Column size="12" className="text-center">
                                <div className="d-flex justify-content-center">

                                    <Pagination
                                        hideNavigation
                                        pageRangeDisplayed={c.DEFAULT_PAGE_RANGE}
                                        activePage={this.state.page}
                                        itemsCountPerPage={this.state.list.pageSize}
                                        totalItemsCount={this.state.list.rowCount == undefined ? 0 : this.state.list.rowCount}
                                        onChange={this.handlePageChange}
                                    />
                                </div>
                            </Column>
                        </Row>
                    </Column>
                </Row>
            </div>
        );
    }
}

class Table extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            selfMain: props.history,
            historyMain: props.history.props.history,
            downloading: false,
            downloadingId: 0
        }
        this.handleDownload = this.handleDownload.bind(this);
        this.convertData = this.convertData.bind(this);
        this.getStatus = this.getStatus.bind(this);
    }

    getStatus(solicitacao, geracao, expurgo) {

        if (solicitacao != null && geracao == null && expurgo == null) {
            return 'Processando';
        } else if (solicitacao != null && geracao != null && expurgo == null) {
            return 'Processado';
        } else if (solicitacao != null && geracao != null && expurgo != null) {
            return 'Expurgado';
        }
    }

    convertData(data) {
        let date = new Date(data);
      
        let dia = ("0" + date.getDate()).slice(-2);
        let mes = ("0" + (date.getMonth() + 1)).slice(-2);
        let ano = date.getFullYear();
      
        let dataFormatada = dia + "/" + mes + "/" + ano;
      
        return dataFormatada;
      }
      

    handleDownload(id, nomeArquivo, expurgo, processado) {

        if (nomeArquivo == null) {
            c.TOASTER_INFO("Arquivo Inexistente.");
            return;
        }

        if (expurgo != null) {
            c.TOASTER_INFO("Arquivo já excluido do sistema.");
            return;
        }
        /*
                if (processado != null) {
                    c.TOASTER_INFO("Arquivo em processamento.");
                    return;
                }
        
                */

        this.setState({ ...this.state, downloading: true, downloadingId: id });
        const url = `${c.API_BASE_URL}/download-relatorio-agendado?id=${id}&nomeArquivo=${nomeArquivo}`;
        const options =
        {
            method: 'GET',
            headers: { 'Authorization': 'Bearer ' + getToken(), 'Content-Type': 'application/json' }
        };

        fetch(url, options)
            .then(response => {

                response.blob().then(blob => {
                    let urlFile = window.URL.createObjectURL(blob);

                    const link = document.createElement("a");
                    link.href = urlFile;
                    link.target = "_blank";
                    link.setAttribute("download", nomeArquivo);
                    document.body.appendChild(link);
                    link.click();

                    this.setState({ ...this.state, downloading: false, downloadingId: 0 });
                });
            });

    }

    render() {
        const loading = this.props.loading;
        const data = this.props.data;

        let html = "";

        if (loading) {
            html = (<tr><td colSpan="7" scope="row">Carregando Agendamentos...</td></tr>);
        }
        else if (data.results === undefined || data.results.length === 0) {
            html = (<tr><td colSpan="7" scope="row">Nenhum registro encontrado.</td></tr>);
        }
        else if (data.results.length > 0) {
            html = data.results.map(row =>
                <tr key={row.id} id={row.id}>
                    <td>{row.id}</td>
                    <td>{this.convertData(row.dataSolicitacao)}</td>
                    <td>{row.filtroDataEnvioInicio ? this.convertData(row.filtroDataEnvioInicio) : "Não selecionada"}</td>
                    <td>{row.filtroDataEnvioFim ? this.convertData(row.filtroDataEnvioFim) : "Não selecionada"}</td>
                    <td>{row.nomeEmpresa}</td>
                    <td>{row.nomeArquivo}</td>
                    <td>{this.getStatus(row.id, row.dataHoraGeracao, row.dataHoraExpurgo)}</td>
                    <td className="text-center">
                        {this.state.downloading && this.state.downloadingId == row[0] ? (
                            <CircularProgress color="inherit" />
                        ) : (
                            <Button background="transparent" border="none" disabled={this.state.downloading} onClick={() => this.handleDownload(row.idArquivo, row.nomeArquivo, row.dataHoraExpurgo, row.dataHoraGeracao)}><Icon name="fa-download" className="mx-1 text-success" /></Button>
                        )
                        }
                    </td>
                </tr>
            );
        }

        return (
            <table className="footable table table-striped toggle-arrow-tiny text-body">
                <thead>
                    <tr style={{ backgroundColor: "#dbf1e9" }}>
                        <th>#</th>
                        <th>Data Agendamento</th>
                        <th>Data inicial</th>
                        <th>Data final</th>
                        <th>Filial</th>
                        <th>Arquivo</th>
                        <th>Status</th>
                        <th className="text-center">Ações</th>
                    </tr>
                </thead>
                <tbody>{html}</tbody>
            </table>
        )
    }
}

function mapStateToProps(state) {
    return { auth: state.auth, relatorio: state.relatorio };
}
function mapDispatchToProps(dispatch) {
    return { actions: { relatorio: bindActionCreators(relatorioAction, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(downloadRelatorio));